export default __webpack_public_path__ + "static/media/logo inicial.3da72a37.jpeg";